// extracted by mini-css-extract-plugin
export var description = "hero-module--description--9fcff";
export var heroExtensionCopySection = "hero-module--heroExtensionCopySection--b41e0";
export var heroShowUpTransition = "hero-module--heroShowUpTransition--8d78c";
export var hidden = "hero-module--hidden--97fa7 hero-module--heroShowUpTransition--8d78c";
export var img = "hero-module--img--09ab0";
export var show = "hero-module--show--52767 hero-module--heroShowUpTransition--8d78c";